"use client"

import type { I18nLocale } from "@/modules/i18n/types"
import type { JobAdCandidacyStatus } from "@/modules/jobAdDetail/types"
import type { FunctionComponent, PropsWithChildren } from "react"

import { Button } from "@jobteaser/spark/components/Button"

import { SHORTLIST_STATUSES } from "@/modules/jobAdDetail/constants"
import { useJobAdDetailTracking } from "@/modules/jobAdDetail/hooks/useJobAdDetailTracking"

import styles from "./DeclineButton.module.css"

type DeclineButtonProps = PropsWithChildren<{
  baseUrl: string
  locale: I18nLocale
  shortlistId: JobAdCandidacyStatus["shortlistId"]
}>

export const DeclineButton: FunctionComponent<DeclineButtonProps> = ({ baseUrl, children, locale, shortlistId }) => {
  const { trackEventClick } = useJobAdDetailTracking()

  const handleClick = (): void => {
    trackEventClick("shortlist_ad_dismiss_click")
    window.location.href = `${baseUrl}/${locale}/shortlists/candidate_statuses/update?shortlist_id=${shortlistId}&status=${SHORTLIST_STATUSES.OFFER_REJECTED}`
  }

  return (
    <Button
      className={styles.main}
      variant="secondary"
      onClick={handleClick}
      data-testid="jobad-DetailView__CandidateActions__not_interested"
    >
      {children}
    </Button>
  )
}
